import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header/Header';
import { useState } from 'react';

export const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex">
      <Header onToggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />

      <Sidebar isOpen={isSidebarOpen} />
      <main
        className={`pt-[70px] w-full min-h-screen transition-all duration-300 overflow-hidden ${
          isSidebarOpen ? 'lg:ml-72' : ''
        }`}
      >
        <Outlet />
      </main>
    </div>
  );
};
